(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["atc-btn-only-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const birthdayBtns = document.querySelectorAll('.js-birthday-gift-btn');
    const disabledBdayBtn = document.querySelector('.js-birthday-gift-btn[disabled]');

    if (birthdayBtns && disabledBdayBtn) {
      birthdayBtns.forEach((btn) => {
        btn.disabled = true;
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
